import styled from '@emotion/styled'
import mq from 'theme/mediaQueries'

export const FormContainer = styled.form`
  display: grid;
  grid-template-columns: auto 45px;
`

export const Filters = styled.div`
  ${mq({
    display: ['block', 'block', 'grid', 'grid'],
  })} 

  max-width: 92%;
  grid-template-columns: 25% 25% 25% 25%;
  column-gap: 15px;
`

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
`
